import { defineComponent as _defineComponent } from 'vue'
import { WccAlertNotification } from '@/models/wccAlertNotification';
import { UserCustomNotificationStatus } from '@/models/customNotifications';
import moment from 'moment';
import { Notification } from '@/store/persistent/index';
import { computed } from 'vue';
import { useI18n } from '@/composables/i18n';
import { getWccNotificationMessage } from '@/utils/alerts';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'NotificationCard',
  props: {
    notification: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ((e: 'click', value: Notification) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  notification: Notification;
};





const i18n = useI18n();

function formatTimestamp(wrongTimestamp: string) {
  // It's 'wrong' because the timezone is missing
  const date = moment(`${wrongTimestamp}+00:00`);
  return date.format('YYYY-MM-DD, HH:mm:ss');
}

const notificationMessage = computed(() => {
  if (props.notification instanceof WccAlertNotification) {
    return getWccNotificationMessage(props.notification);
  } else if (props.notification instanceof UserCustomNotificationStatus) {
    return props.notification.messageTxt;
  } else {
    // instanceof AlertWorkflowNotification
    return i18n.t('alert.alert_workflow_notification_message', {
      deviceName: props.notification.deviceName,
      customerName: props.notification.customerName,
    });
  }
});

return { __sfc: true,props, emit, i18n, formatTimestamp, notificationMessage }
}

})